import { InventoryState } from './inventoryState';

export class InventoryDistrict {
    id: string;
    name: string;
    state: InventoryState = new InventoryState();
}